export const ACTION = {
  LOGIN: 'LOGIN',
  LOGOUT: 'LOGOUT',
  LOADING: 'LOADING',
  GET_PRODUCTS: 'GET_PRODUCTS',
  GET_STORE: 'GET_STORE',
  SELECT_VALUE: 'SELECT_VALUE',
  ERROR: 'ERROR',
  CHANGE_SIDER: 'CHANGE_SIDER',
}

//co 6 role mac dinh
export const ROLE_DEFAULT = {
  ADMIN: 'ADMIN',
  EMPLOYEE: 'EMPLOYEE',
  BUSINESS: 'BUSINESS',
}

//status product
export const STATUS_PRODUCT = {
  all: 'all',
  shipping_stock: 'shipping_stock',
  available_stock: 'available_stock',
  low_stock: 'low_stock',
  out_stock: 'out_stock',
}

//status order
export const BILL_STATUS_ORDER = {
  DRAFT: 'DRAFT',
  PROCESSING: 'PROCESSING',
  COMPLETE: 'COMPLETE',
  CANCEL: 'CANCEL',
  REFUND: 'REFUND',
}

export const SHIP_STATUS_ORDER = {
  DRAFT: 'DRAFT',
  WATTING_FOR_SHIPPING: 'WATTING_FOR_SHIPPING',
  SHIPPING: 'SHIPPING',
  COMPLETE: 'COMPLETE',
  CANCEL: 'CANCEL',
}

export const ROUTES = {
  LOGIN: '/login',
  ORDER_lyST: '/order-list',
  DOMAIN: '/domain',
  OTP: '/otp',
  BLOG: '/blog',
  MENU: '/menu',
  SETMENU: '/setmenu',
  SETMENU_CREATE: '/setmenu/create',
  SETMENU_UPDATE: '/setmenu/update',
  MENU_CREATE: '/menu/create',
  MENU_UPDATE: '/menu/update',
  BLOG_CREATE: '/blog/create',
  BLOG_UPDATE: '/blog/update',
  TOPPING: '/topping',
  PASSWORD_NEW: '/password-new',
  FORGET_PASSWORD: '/forget-password',
  BRANCH: '/branch',
  BLOCK_ORDER: '/block-order',
  BOOKING_STATISTIC: '/booking-statistic',
  INVITATION: '/invitation',
  CUSTOMER: '/customer',
  REGION: '/region',
  COUNTRY: '/country',
  ORDER_CREATE: '/order-create',
  PRODUCT: '/product',
  PRODUCT_ADD: '/product/create',
  PRODUCT_UPDATE: '/product/update',
  SOUVENIR: '/souvenir',
  SOUVENIR_ADD: '/souvenir/create',
  SOUVENIR_UPDATE: '/souvenir/update',
  PAYMENT: '/payment',
  TAX: '/tax',
  SERVICE_FEE: '/service-fee',
  EMAIL_MANAGER: '/email-manager',
  ROLE: '/role',
  EMPLOYEE: '/employee',
  SUPPLIER: '/supplier',
  PROMOTION: '/promotion',
  PROMOTION_CREATE: '/promotion-create',
  PROMOTION_UPDATE: '/promotion-update',
  VOUCHER: '/voucher',
  VOUCHER_GIFT: '/voucher-gift',
  CATEGORY: '/category',
  CATEGORIES: '/categories',
  OFFER_lyST: '/offer-list',
  OFFER_lyST_CREATE: '/offer-list/create',
  TABLE: '/table',
  COMMENT: '/comment',
  REVIEW: '/review',
  ORDER_LIST: '/order-list',
  DATA_DELETION_POLICY: '/data-deletion-policy',
  GIFTCARD: '/giftcard',
  GIFTCARD_FROM: '/giftcard-form',
  PRODUCT_TYPE: '/product-type',
}

export const PERMISSIONS = {
  //Permission menu
  tong_quan: 'tong_quan',
  // ban_hang: 'ban_hang',
  // danh_sach_don_hang: 'danh_sach_don_hang',
  // phan_loai_mon: 'phan_loai_mon',
  // quan_ly_thuc_don: 'quan_ly_thuc_don',
  // business_management: 'business_management',
  // san_pham: 'san_pham',
  // quan_ly_chi_nhanh: 'quan_ly_chi_nhanh',
  // quan_ly_san_pham: 'quan_ly_san_pham',
  // quan_ly_kho: 'quan_ly_kho',
  // quan_ly_chuyen_hang: 'quan_ly_chuyen_hang',
  // quan_ly_nha_cung_cap: 'quan_ly_nha_cung_cap',
  // quan_ly_bao_hanh: 'quan_ly_bao_hanh',
  // khuyen_mai: 'khuyen_mai',
  // kiem_hang_cuoi_ngay: 'kiem_hang_cuoi_ngay',
  // quan_ly_khach_hang: 'quan_ly_khach_hang',
  // bao_cao_don_hang: 'bao_cao_don_hang',
  // bao_cao_nhap_hang: 'bao_cao_nhap_hang',
  // bao_cao_ton_kho: 'bao_cao_ton_kho',
  // bao_cao_tai_chinh: 'bao_cao_tai_chinh',
  // van_chuyen: 'van_chuyen',
  // doi_soat_van_chuyen: 'doi_soat_van_chuyen',
  // quan_ly_doi_tac_van_chuyen: 'quan_ly_doi_tac_van_chuyen',
  // cau_hinh_thong_tin: 'cau_hinh_thong_tin',
  // quan_ly_phan_quyen: 'quan_ly_phan_quyen',
  // tich_diem: 'tich_diem',
  // quan_ly_uu_dai: 'quan_ly_uu_dai',
  don_hang: 'don_hang',
  quan_ly_dat_ban: 'quan_ly_dat_ban',
  quan_ly_nhan_xet: 'quan_ly_nhan_xet',
  phan_loai_mon: 'phan_loai_mon',
  quan_ly_mon_an: 'quan_ly_mon_an',
  quan_ly_thuc_don: 'quan_ly_thuc_don',
  topping: 'topping',
  quan_ly_thue: 'quan_ly_thue',
  quan_ly_phi_dich_vu: 'quan_ly_phi_dich_vu',
  quan_ly_nhan_vien: 'quan_ly_nhan_vien',
  quan_ly_khach_hang: 'quan_ly_khach_hang',
  quan_ly_chi_nhanh: 'quan_ly_chi_nhanh',
  quan_ly_block_order: 'quan_ly_block_order',
  quan_ly_invitation: 'quan_ly_invitation',
  quan_ly_khu_vuc: 'quan_ly_khu_vuc',
  quan_ly_quoc_gia: 'quan_ly_quoc_gia',
  quan_ly_bai_viet: 'quan_ly_bai_viet',
  quan_ly_qua_luu_niem: 'quan_ly_qua_luu_niem',
  chuong_trinh_khuyen_mai: 'chuong_trinh_khuyen_mai',
  quan_ly_voucher_da_mua: 'quan_ly_voucher_da_mua',
  quan_ly_voucher_da_tang: 'quan_ly_voucher_da_tang',
  phuong_thuc_thanh_toan: 'phuong_thuc_thanh_toan',
  cai_dat_email_quan_ly: 'cai_dat_email_quan_ly',
  quan_ly_phan_quyen: 'quan_ly_phan_quyen',

  //Permission function
  tao_phan_loai_mon: 'tao_phan_loai_mon',
  cap_nhat_phan_loai_mon: 'cap_nhat_phan_loai_mon',
  them_mon_an: 'them_mon_an',
  cap_nhat_mon_an: 'cap_nhat_mon_an',
  them_thuc_don: 'them_thuc_don',
  cap_nhat_thuc_don: 'cap_nhat_thuc_don',
  them_bai_viet: 'them_bai_viet',
  cap_nhat_bai_viet: 'cap_nhat_bai_viet',
  them_chuong_trinh_khuyen_mai: 'them_chuong_trinh_khuyen_mai',
  cap_nhat_chuong_trinh_khuyen_mai: 'cap_nhat_chuong_trinh_khuyen_mai',
  cap_nhat_chuong_trinh_khuyen_mai: 'cap_nhat_chuong_trinh_khuyen_mai',
  bao_cao_booking: 'bao_cao_booking',
  quan_ly_setmenu: 'quan_ly_setmenu',
  // them_cua_hang: 'them_cua_hang',
  // tao_don_hang: 'tao_don_hang',
  // nhom_san_pham: 'nhom_san_pham',
  // them_san_pham: 'them_san_pham',
  // xoa_san_pham: 'xoa_san_pham',
  // tao_nhom_san_pham: 'tao_nhom_san_pham',
  // xoa_nhom_san_pham: 'xoa_nhom_san_pham',
  // cap_nhat_nhom_san_pham: 'cap_nhat_nhom_san_pham',
  // tao_phieu_chuyen_hang: 'tao_phieu_chuyen_hang',
  // them_kho: 'them_kho',
  // cap_nhat_kho: 'cap_nhat_kho',
  // cap_nhat_trang_thai_phieu_chuyen_hang: 'cap_nhat_trang_thai_phieu_chuyen_hang',
  // them_nha_cung_cap: 'them_nha_cung_cap',
  // cap_nhat_nha_cung_cap: 'cap_nhat_nha_cung_cap',
  // them_phieu_bao_hanh: 'them_phieu_bao_hanh',
  // them_khuyen_mai: 'them_khuyen_mai',
  // them_phieu_kiem_hang: 'them_phieu_kiem_hang',
  // them_khach_hang: 'them_khach_hang',
  // cap_nhat_khach_hang: 'cap_nhat_khach_hang',
  // them_phieu_doi_soat_van_chuyen: 'them_phieu_doi_soat_van_chuyen',
  // them_doi_tac_van_chuyen: 'them_doi_tac_van_chuyen',
  // cap_nhat_doi_tac_van_chuyen: 'cap_nhat_doi_tac_van_chuyen',
  // xoa_doi_tac_van_chuyen: 'xoa_doi_tac_van_chuyen',
  // them_chi_nhanh: 'them_chi_nhanh',
  // cap_nhat_chi_nhanh: 'cap_nhat_chi_nhanh',
  // quan_ly_cua_hang: 'quan_ly_cua_hang',
  // quan_ly_nguoi_dung: 'quan_ly_nguoi_dung',
  // them_nguoi_dung: 'them_nguoi_dung',
  // quan_ly_nhan_su: 'quan_ly_nhan_su',
  // them_nhan_su: 'them_nhan_su',
  // cap_nhat_nhan_su: 'cap_nhat_nhan_su',
  // quan_ly_thue: 'quan_ly_thue',
  // them_thue: 'them_thue',
  // quan_ly_thanh_toan: 'quan_ly_thanh_toan',
  // them_hinh_thuc_thanh_toan: 'them_hinh_thuc_thanh_toan',
  // nhap_xuat_file: 'nhap_xuat_file',
  // nhat_ki_hoat_dong: 'nhat_ki_hoat_dong',
  // tao_quyen: 'tao_quyen',
  // tao_uu_dai: 'tao_uu_dai',
  // tao_bai_viet: 'tao_bai_viet',
  // tao_thuong_hieu: 'tao_thuong_hieu',
  // tao_kenh_ban_hang: 'tao_kenh_ban_hang',
}

export const VERSION_APP = '1.1.6'

export const regexPhone = /\(?([0-9]{3})\)?([ .-]?)([0-9]{3})\2([0-9]{4})/

export const IMAGE_DEFAULT =
  'https://s3.ap-northeast-1.wasabisys.com/admin-order/2021/11/08/757a2f95-f144-4963-8e11-931bafdee356/image_default.jpg'

export const PAGE_SIZE = 20
export const PAGE_SIZE_OPTIONS = [20, 40, 50, 60, 80, 100]
export const POSITION_TABLE = ['bottomLeft']

export const TIME_SLOTS = [
  { name: '5:00 AM', value: '05:00', disabled: true, unavailable: true },
  { name: '5:30 AM', value: '05:30', disabled: true, unavailable: true },
  { name: '6:00 AM', value: '06:00', disabled: true, unavailable: true },
  { name: '6:30 AM', value: '06:30', disabled: true, unavailable: true },
  { name: '7:00 AM', value: '07:00', disabled: true, unavailable: true },
  { name: '7:30 AM', value: '07:30', disabled: true, unavailable: true },
  { name: '8:00 AM', value: '08:00', disabled: true, unavailable: true },
  { name: '8:30 AM', value: '08:30', disabled: true, unavailable: true },
  { name: '9:00 AM', value: '09:00', disabled: true, unavailable: true },
  { name: '9:30 AM', value: '09:30', disabled: true, unavailable: true },
  { name: '10:00 AM', value: '10:00', disabled: true, unavailable: true },
  { name: '10:30 AM', value: '10:30', disabled: true, unavailable: true },
  { name: '11:00 AM', value: '11:00', disabled: false },
  { name: '11:30 AM', value: '11:30', disabled: false },
  { name: '12:00 PM', value: '12:00', disabled: false },
  { name: '12:30 PM', value: '12:30', disabled: false },
  { name: '1:00 PM', value: '13:00', disabled: false },
  { name: '1:30 PM', value: '13:30', disabled: false },
  { name: '2:00 PM', value: '14:00', disabled: false },
  { name: '2:30 PM', value: '14:30', disabled: false },
  { name: '3:00 PM', value: '15:00', disabled: false },
  { name: '3:30 PM', value: '15:30', disabled: false },
  { name: '4:00 PM', value: '16:00', disabled: false },
  { name: '4:30 PM', value: '16:30', disabled: false },
  { name: '5:00 PM', value: '17:00', disabled: false },
  { name: '5:30 PM', value: '17:30', disabled: false },
  { name: '6:00 PM', value: '18:00', disabled: false },
  { name: '6:30 PM', value: '18:30', disabled: false },
  { name: '7:00 PM', value: '19:00', disabled: false },
  { name: '7:30 PM', value: '19:30', disabled: false },
  { name: '8:00 PM', value: '20:00', disabled: false },
  { name: '8:30 PM', value: '20:30', disabled: false },
  { name: '9:00 PM', value: '21:00', disabled: false },
  { name: '9:30 PM', value: '21:30', disabled: false },
  { name: '10:00 PM', value: '22:00', disabled: false },
  { name: '10:30 PM', value: '22:30', disabled: false },
  { name: '11:00 PM', value: '23:00', disabled: false },
  { name: '11:30 PM', value: '23:30', disabled: false },
];